import React from "react";
import { BrowserRouter } from "react-router-dom";
import "@/App.css";
import "@/i18n";

import { AuthProvider } from "@/app/providers/AuthProvider";
import { AppRouter } from "@/app/router/AppRouter";
import { AppErrorBoundary } from "@/app/AppErrorBoundary";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <AppErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster
            position="top-right"
            offset={80}
            toastOptions={{
              classNames: {
                toast:
                  "!bg-surface !border-border-subtle !text-text-primary !shadow-elevated",
                title: "!text-text-primary",
                description: "!text-text-secondary",
                success: "!border-l-4 !border-l-status-available",
                error: "!border-l-4 !border-l-status-unavailable",
              },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </AppErrorBoundary>
  );
}

export default App;
